export const graphqlBaseUrl = "";
export const paysackBaseUrl = "https://api-stage.paysack.com/";
export const SOLANA_CLUSTER = "";
export const SOL_LEDGER_ACCOUNT = "";
